import { useEffect, useState, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import Overlay from '../../Components/Overlay';
import Swal from 'sweetalert2';
import { getSync } from '../../Service/SyncService';

const { $ } = window;

const SyncPage = () => {
    const tableRoles = useRef();
    const [state, setStates] = useState({
        processing: false,
    });

    const menus = [
        { _id: 1, name: 'PPN', value: 'ppn' },
        { _id: 2, name: 'PPH', value: 'pph' },
        { _id: 3, name: 'Product', value: 'product' },
        { _id: 4, name: 'Order Type', value: 'ordertype' },
        { _id: 5, name: 'BP', value: 'bp' },
        { _id: 6, name: 'BP Adress', value: 'bpaddress' },
        { _id: 7, name: 'BP Branch', value: 'bpbranch' },
        { _id: 8, name: 'Warehouse', value: 'warehouse' },
        { _id: 9, name: 'Series', value: 'series' },
    ];

    const getData = payload => {
        var promise = new Promise((resolve, reject) => {
            const result = {
                data: {
                    data: menus,
                    from: 1,
                    to: 10,
                    per_page: 10,
                    total: 8,
                    total_page: 1
                }
            };
            resolve(result);
        });
        return promise;
    };

    const setState = data => {
        setStates({ ...state, ...data });
    }

    const columns = [
        { id: 1, title: 'Name', field: 'name', sortable: true },
        {
            id: 3, title: 'Action', field: 'name', width: 150,
            render: (item) => (
                <div>
                    <button type='button' className='btn text-warning' onClick={onSyncClick(item)}><i className="fa fa-sync"></i> Sync</button>
                </div>
            )
        }
    ];

    const onSyncClick = item => () => {
        Swal.fire(
            {
                icon: 'question',
                title: 'Are you sure?',
                text: 'Sync Master Data ' + item.name + '!',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {
                setState({ processing: true })
                getSync(item.value).then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Sync Master Data ' + item.name + ' success!'
                    }).then(res => {
                        tableRoles.current.refresh();

                    });
                }).catch(({ response }) => {
                    const { message } = response?.data;
                    Swal.fire({
                        icon: 'error',
                        title: `Sync error!`,
                        text: message
                    });
                }).finally(() => {
                    setState({ processing: false })
                })
            }
        })
    }

    const propsTable = { columns, getData: getData, showIndex: true, hideFilter: true };
    const { name, is_active, salesorder, salesorderapproval, purchaseorder, delivery, inventorytransfer, productstock, operationalcost, withdrawal, role, user, _id, processing, is_view } = state;

    return (
        <div className="content-wrapper">
            <Overlay display={state.processing} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Sync SAP</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <div className='table-responsive'>
                                <MTable ref={tableRoles} {...propsTable} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default SyncPage